module.exports = __webpack_public_path__ + "img/app-anwang.e3ad31d2.webp";